<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="任务名称:" prop="taskName">
                        <el-input
                        v-model="queryParams.taskName"
                        placeholder="请输入任务名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="发布日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endTime"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <p>任务数量:<b>{{total}}</b>个</p>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="rwzxList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="任务名称" prop="title" />
                    <el-table-column label="任务描述" prop="taskDescribe" />
                    <el-table-column label="发布时间" prop="createTime" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">{{getDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="截止领取时间" prop="deadlineReceiveTime"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.deadlineReceiveTime">{{getDate(scope.row.deadlineReceiveTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="截止上传时间" prop="deadlineUploadTime"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.deadlineUploadTime">{{getDate(scope.row.deadlineUploadTime,'yyyy-MM-dd')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="发布状态" align="center" class-name="small-padding fixed-width" width="80" >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.type == 0"  size="small" type="info">待发布</el-tag>
                            <el-tag v-else-if="scope.row.type == 1"  size="small" type="warning">已发布</el-tag>
                            <el-tag v-else-if="scope.row.type == 2"  size="small" type="primary">已领取</el-tag>
                            <el-tag v-else size="small" type="success">已评查</el-tag>
                        </template>
                    </el-table-column>

                    <!--<el-table-column label="PDF地址" prop="pdfUrl" />
                    <el-table-column label="地区" align="center" prop="strCmid" />
                    <el-table-column label="状态" align="center" class-name="small-padding fixed-width" width="80" >
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0"  size="small" type="primary">正常</el-tag>
                            <el-tag v-else size="small" type="success">停用</el-tag>
                        </template>
                    </el-table-column>-->
                    <el-table-column label="备注" prop="remark" >
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="bottom-start">
                                <span class="table-remark" style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ scope.row.remark }}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180" >
                        <template slot-scope="scope">
                            <el-button
                                size="small"
                                type="text"
                                @click="handleAll(scope.row.id)"
                            >详情</el-button>
                            <el-button
                                size="small"
                                type="text"
                                @click="handleLq(scope.row.id)"
                            >领取状态</el-button>
                            <el-button v-if="scope.row.type == 0"
                                size="small"
                                type="text"
                                @click="handleEdit(scope.row.id)"
                            >发布</el-button>
                            <el-button v-if="scope.row.type == 0"
                                size="small"
                                type="text"
                                @click="handleRemove(scope.row.id)"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <el-dialog title="任务领取状态" :visible.sync="open" width="600px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <el-tabs v-model="activeName">
                <el-tab-pane label="已领取" name="first">
                    <el-form :model="queryParams2" ref="queryForm2" :inline="true">
                        <el-form-item label="地区:" prop="name">
                            <el-input v-model="queryParams2.name" clearable size="small" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="handleQuery2">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table v-loading="loading2" :data="ylqList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams2.limit * (queryParams2.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="地区" prop="name" />
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow2"
                            background
                            @size-change='handleSizeChange2'
                            @current-change='handleCurrentChange2'
                            :current-page="queryParams2.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams2.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total2" style=" float:right;">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="未领取" name="second">
                    <el-form :model="queryParams3" ref="queryForm3" :inline="true">
                        <el-form-item label="地区:" prop="name">
                            <el-input v-model="queryParams3.name" clearable size="small" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="handleQuery3">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table v-loading="loading3" :data="wlqList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams3.limit * (queryParams3.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="地区" prop="name" />
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow3"
                            background
                            @size-change='handleSizeChange3'
                            @current-change='handleCurrentChange3'
                            :current-page="queryParams3.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams3.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total3" style=" float:right;">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <el-dialog title="任务详情" :visible.sync="open2" width="80%" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <el-form :model="queryParams4" ref="queryForm4" :inline="true">
                <el-form-item label="市:" prop="shi">
                    <el-select size="small" clearable v-model="queryParams4.shi" @change="getXianqu">
                        <el-option v-for="(item,index) in shiOptions" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="县区:" prop="xianqu">
                    <el-select size="small" clearable v-model="queryParams4.xianqu">
                        <el-option v-for="(item,index) in xianquOptions" :key="index" :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务名称:" prop="title">
                    <el-input
                    v-model="queryParams4.title"
                    placeholder="请输入任务名称"
                    clearable
                    size="small"
                    @keyup.enter.native="handleQuery"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery4">查询</el-button>
                    <el-button icon="el-icon-refresh" size="small" @click="resetQuery4">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="loading4" :data="rwxqList">
                <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                    <template slot-scope="scope">
                        <span>{{(scope.$index+1) + ( queryParams4.limit * (queryParams4.page-1))}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="地区" prop="xianqu" width="80" />
                <el-table-column label="监督单位名称" prop="name" />
                <el-table-column label="任务名称" prop="title" />
                <el-table-column label="上传时间"  align="center" prop="createTime" width="100" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{getDate(scope.row.createTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测评状态" align="center" prop="assessStatusName" width="80" >
                    <template slot-scope="scope">
                        <el-tag  size="small" :type="scope.row.assessStatus == '1'?'success':'info'">{{scope.row.assessStatusName}}</el-tag>
                    </template>
                </el-table-column> 
                <el-table-column label="得分" align="center" prop="score" width="80" />
                <el-table-column label="被处罚名称" align="center" prop="punishedPerson" width="160"  />
                <el-table-column label="案由" prop="causeOfAction" />
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="getPcImg(scope.row.id)">评查详情</el-button>
                        <el-button size="mini" type="text" @click="handlePcaj(scope.row.id)">查看案卷</el-button>
                        <el-button v-if="scope.row.status == 1" size="mini" type="text" @click="handlePc(scope.row)">评查</el-button>
                    </template> 
                </el-table-column>
            </el-table>
            <div class="page-part" style="padding:20px 20px 50px;">
                <el-pagination  v-if="pageshow4"
                    background
                    @size-change='handleSizeChange4'
                    @current-change='handleCurrentChange4'
                    :current-page="queryParams4.page"
                    :page-sizes="[10,20,30,40]"
                    :page-size="queryParams4.limit"
                    layout="total, prev, pager, next, jumper"
                    :total="total4" style=" float:right;">
                </el-pagination>
            </div>
        </el-dialog>

        <el-dialog title="评查详情" :visible.sync="open5" width="1000px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">评查得分</span>：{{pcdf}}</h3>
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">违法程度</span>：{{wfcd}}</h3>
            <h3 style="display: flex; align-items: center;margin-bottom:5px;"><span style="width:67px;text-align: justify; text-align-last: justify;">案  由</span>：{{anyou}}</h3>
            <el-table v-loading="loadingSc" :data="pcjgList">
                <el-table-column align="center" label="序号" type="index" width="60" />                
                <el-table-column align="center" label="评查指标" prop="name" />
                <el-table-column align="center" label="是否合格" prop="correct" width="80" >
                    <template slot-scope="scope">
                        <el-tag size="small" :type="(scope.row.correct === 'true') ? 'success' : 'danger'">
                            {{ (scope.row.correct === 'true') ? "合格" : "不合格" }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="审核描述" prop="describe"  />
                <el-table-column align="center" label="扣分" prop="fz" width="60" />
                <el-table-column align="center" label="评查人" prop="dmName" width="80" />
                <el-table-column align="center" label="审核人" prop="updateName" width="80" />
                <el-table-column align="center" label="审核时间" prop="updateTime"  width="120" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.updateTime">{{getDate(scope.row.updateTime,'yyyy-MM-dd')}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="查看案卷" :visible.sync="open6" width="600px" top="5vh" append-to-body class="newTk" :close-on-click-modal="false" style="min-height: 500px;">
            
            <div class="anjuan" v-loading="loadingAj">
                <!--<h3>{{ajbt}}</h3><div class="menus">
                    <el-scrollbar ref="myScrollbar">
                        <ul>
                            <li v-for="(item,index) in ajNames" :key="index" :class="isIndex == index?'active':''" @click="showWs(item,index)">
                                <p><i class="el-icon-document"></i>&nbsp;{{ item.name }}</p>
                            </li>
                        </ul>
                    </el-scrollbar>
                </div>-->
                <div class="imgW">
                    <el-scrollbar ref="myScrollbar2">
                        <p v-show="ajImgs" v-for="(item,index) in ajImgs" :key="index">
                            <img :src="item" @dblclick="showBig(item)" />
                        </p>
                        <!--<el-button type="text" size="small" v-show="ajImgs[isIndex]" @click="showText(1)" style="position: absolute; top: 15px; left: 10px;box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);">相关参数</el-button>-->
                    </el-scrollbar>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="案卷文书" :visible.sync="openBig" top="20px" :width="isH?'700px':'1200px'" append-to-body ref="rotate"  :close-on-click-modal="false">
            <div style="text-align: right; margin-right: 40px;  position: absolute; right: 10px; top: 8px;">
            <el-button type="warning" size="small" @click="rotate">旋转</el-button></div>
            <!--<p v-show="bigSrcs" v-for="(item,index) in bigSrcs" :key="index" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;">
                <img :src="item" style="width: 100%;" />
            </p>-->
            <p v-show="bigSrc" ref="rotate" :style="{'width':isH?'100%':'70%'}" style="margin: 0px auto;"><img :src="bigSrc"  style="width: 100%;" /></p>
        </el-dialog>

        <div v-show="loading5"  style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.05); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
            <div class="load" style="position: absolute;padding-top: 40px; z-index: 2;    background: linear-gradient(128deg, rgb(255, 255, 255) 40%, rgb(230, 240, 252)); width: 700px; height: 400px; border-radius: 4px; top: 18vh; left: 50%;  margin-left: -350px;  text-align: center;">
                <img style="margin: 30px auto 30px;" src="../../../assets/images/loading.png" />
                <p style="font-weight: bold; font-size: 18px;">案卷正在评查，预计需要1~5分钟,请不要关闭页面...</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                taskName:'',
                startTime:'',
                endTime:'',
                page:1,
                limit:10,
            },
            total:0,
            rwzxList:[],
            ztOptions:[],
            open:false,
            pageshow:true,
            cmid:'',
            sc: "",
            xg: "",
            xz: "",
            yhsfId: '',
            loading2: false,
            loading3: false,
            ylqList: [],
            wlqList: [],
            activeName: 'first',
            queryParams2:{
                name: '',
                page:1,
                limit:10
            },
            queryParams3:{
                name: '',
                page:1,
                limit:10
            },
            total2:0,
            total3:0,
            pageshow2:true,
            pageshow3:true,
            lqId: '',
            open2:false,
            queryParams4:{
                page:1,
                limit:10,
                shi: '全部',
                xianqu:'全部',
                title:''
            },
            rwxqList:[],
            total4:0,
            loading4:false,
            pageshow4:true,
            xqId:'',
            shiOptions: [],
            xianquOptions:[],
            loadingSc: false,
            loading5:false,
            open5:false,
            pcdf: 0,
            wfcd:'',
            anyou:'',
            zfs: 0,
            pcjgList:[],
            open6:false,
            ajbt:'',
            ajNames:[],
            ajImgs:[],
            isIndex:0,
            loadingAj: false,
            openBig: false,
            bigSrc: '',
            isH: false,
            deg:0,
            loadingPc: false,
            baseUrl:''
        };
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '任务管理'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.yhsfId = user.yhsfId
        this.baseUrl = user.baseUrl
        this.getList()
        this.getShi()
    },
    methods: {
        async getList(){
            this.rwzxList = []
            this.total = 0
            
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/list`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    taskName:this.queryParams.taskName,
                    startTime:this.queryParams.startTime,
                    endTime:this.queryParams.endTime,
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.rwzxList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleEdit(id){
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/updateRelease`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id:id
                }
            })
            .then(res => {
                console.log(res,244)
                this.loading = false
                if(res.data.code == 0){
                    this.$message.success('发布成功！');
                    this.getList()
                }else{
                    this.$message.error(res.data.msg || '发布失败，请联系管理员！');
                }
            })
            .catch(error => {
                this.$message({
                    message: error.data.msg ? error.data.msg : '发布失败，请联系管理员！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        resetQuery(){
            this.queryParams = {
                taskName:'',
                startTime:'',
                endTime:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        handleLq(id){
            this.ylqList = []
            this.wlqList = []
            this.open = true
            this.lqId = id
            this.getYlq(id)
            this.getWlq(id)
        },
        getYlq(id){
            this.loading2 = true
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/receivedAlready`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                    name: this.queryParams2.name,
                    pageSize:this.queryParams2.limit,
                    pageNum:this.queryParams2.page
                }
            })
            .then(response => {
                console.log(response);
                this.ylqList = response.data.data.list
                this.total2 = response.data.data.total
                this.loading2 = false
            })
            .catch(error => {
                this.loading2 = false
                console.error('There was an error!', error);
            });
        },
        handleQuery2(){
            this.pageshow2 = false;
            this.queryParams2.page = 1
            this.getYlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow2 = true;
            });
        },
        handleQuery3(){
            this.pageshow3 = false;
            this.queryParams3.page = 1
            this.getWlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow3 = true;
            });
        },
        getWlq(id){
            this.loading3 = true
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/unclaimed`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                    name: this.queryParams3.name,
                    pageSize:this.queryParams3.limit,
                    pageNum:this.queryParams3.page
                }
            })
            .then(response => {
                console.log(response);
                this.wlqList = response.data.data.list
                this.total3 = response.data.data.total
                this.loading3 = false
            })
            .catch(error => {
                this.loading3 = false
                console.error('There was an error!', error);
            });
        },
        handleSizeChange2(val){
            this.queryParams2.limit = val
            this.getYlq(this.lqId)
        },
        handleCurrentChange2(val){
            this.pageshow2 = false;
            this.queryParams2.page = val
            this.getYlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow2 = true;
            });
        },
        handleSizeChange3(val){
            this.queryParams3.limit = val
            this.getWlq(this.lqId)
        },
        handleCurrentChange3(val){
            this.pageshow3 = false;
            this.queryParams3.page = val
            this.getWlq(this.lqId)
            this.$nextTick(() => {
                this.pageshow3 = true;
            });
        },
        handleSizeChange4(val){
            this.queryParams4.limit = val
            this.getXq(this.xqId)
        },
        handleCurrentChange4(val){
            this.pageshow4 = false;
            this.queryParams4.page = val
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        handleQuery4(){
            this.pageshow4 = false;
            this.queryParams4.page = 1
            this.getXq(this.xqId)
            this.$nextTick(() => {
                this.pageshow4 = true;
            });
        },
        resetQuery4(){
            this.queryParams4 = {
                page:1,
                limit:10,
                title:'',
                xianqu:'全部',
                shi:'全部',
            }
            this.getXq(this.xqId)
        },
        handleAll(id){
            this.open2 = true;
            this.xqId = id
            this.rwxqList = []
            this.queryParams4 = {
                page:1,
                limit:10,
                title:'',
                xianqu:'全部',
                shi:'全部',
            }
            this.getXq(id)
        },
        getShi(){
            this.shiOptions = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/shi`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
            })
            .then(response => {
                console.log(response);
                this.shiOptions = response.data.data
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getXianqu(){
            this.xianquOptions = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/xianqu`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    name: this.queryParams4.shi
                }
            })
            .then(response => {
                console.log(response);
                this.xianquOptions = response.data.data
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        getXq(id){
            console.log(this.xqId, this.queryParams4.title, this.queryParams4.xianqu)
            this.loading4 = true
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/detailsList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                    title:this.queryParams4.title,
                    shi:this.queryParams4.shi,
                    xianqu:this.queryParams4.xianqu,
                    pageSize:this.queryParams4.limit,
                    pageNum:this.queryParams4.page
                }
            })
            .then(response => {
                console.log(response);
                this.rwxqList = response.data.data.list
                this.total4 = response.data.data.total
                this.loading4 = false
            })
            .catch(error => {
                this.loading4 = false
                console.error('There was an error!', error);
            });
        },
        handleRemove(id){
            this.$confirm("此操作将永久删除该未发布任务, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: `https://xxswj.hzxhykj.com:9086/system/release/releasedDel`,
                    headers: { // 添加请求头
                        "Content-Type": "application/json" // 明确声明为 JSON 格式
                    },
                    data: {
                        id: id
                    }
                })
                .then(res => {
                    console.log(res,345)
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getList()
                })   
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });		
        },
        handlePc(row){
            this.loading5 = true
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/taskEvaluation`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: row.id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.getPcImg(row.id)
                    this.getXq(this.xqId)
                    this.loading5 = false
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                //this.pcsrc = response.data.data
                this.loading5 = false
            })
            .catch(error => {
                this.loading5 = false
                console.error('There was an error!', error);
            });
        },
        getPcImg(id){ 
            this.pcjgList = []
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/evaluationResult`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.open5 =  true
                    this.pcjgList = response.data.data.evaluationResultResList
                    this.pcdf = response.data.data.sumFz || 0
                    this.wfcd = response.data.data.wfcd || ''
                    this.anyou = response.data.data.anyou || ''
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        handlePcaj(id){
            this.open6 = true
            this.loadingAj = true
            this.ajImgs = []
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/viewCaseFile`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: id,
                }
            })
            .then(response => {
                console.log(response,686);
                if(response.data.code == 0 ){
                    this.ajImgs = response.data.data.imgList
                }else{
                    this.$message.error(response.data.msg ? response.data.msg : '加载失败，请重试！')
                }
                this.loadingAj = false
            })
            .catch(error => {
                this.loadingAj = false
                console.error('There was an error!', error);
            });
        },
        showBig(src){
            this.bigSrc = src
            this.openBig = true
            this.isH = true
            this.$refs.rotate.style.transform = `rotate(0deg)`
        },
        // 旋转图片
        rotate () {
            this.isH = false
            this.deg += 90
            if (this.deg >= 360) {
                this.deg = 0
            }
            this.$refs.rotate.style.transform = `rotate(${this.deg}deg)`
        },
    }
}
</script>


<style scoped>
.anjuan{ width:100%; overflow:hidden; height:80vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.anjuan >>> .el-scrollbar { width: 100%; height: 100%;}
.anjuan >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.anjuan >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.anjuan >>> .el-scrollbar__view{min-height: 100%;}
.anjuan .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.anjuan h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.anjuan ul{width: 180px;margin-right: 10px;padding-bottom: 10px}
.anjuan ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.anjuan ul li.active{color:#1890ff;}
.imgW{width: 100%;  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
</style>